export const authScreenLabels = {
    fr: {
        'Account recovery requires verified contact information':
            'La récupération du compte nécessite des informations de contact vérifiées',
        'An account with the given email already exists.':
            'Un utilisateur avec cette adresse email existe déjà.',
        'Back to Sign In': 'Retour à la connexion',
        'Change': 'Modifier',
        'Change Password': 'Modifier le mot de passe',
        'Code': 'Code',
        'Confirm': 'Confirmer',
        'Confirm a Code': 'Confirmer un code',
        'Confirm Password': 'Confirmez le mot de passe',
        'Confirm Sign In': 'Confirmer la connexion',
        'Confirm Sign Up': "Confirmer l'inscription",
        'Confirm SMS Code': 'Confirmer le code SMS',
        'Confirm TOTP Code': 'Confirmer le code TOTP',
        'Confirmation Code': 'Code de confirmation',
        'Create a new account': 'Créer un nouveau compte',
        'Create account': 'Créer un compte',
        'Create Account': 'Créer un compte',
        'Email': 'Email',
        'Enter your code': 'Saisissez cotre code de confirmation',
        'Enter your email': 'Saisissez votre adresse email',
        'Enter your password': 'Saisissez votre mot de passe',
        'Enter your phone number': 'Saisissez votre numéro de téléphone',
        'Enter your username': "Saisissez votre nom d'utilisateur",
        'Forgot Password': 'Mot de passe oublié',
        'Forgot your password?': 'Mot de passe oublié ? ',
        'Have an account? ': 'Déjà un compte ? ',
        'Hello': 'Bonjour',
        'Incorrect username or password.': 'Identifiant ou mot de passe incorrect.',
        'Invalid password format': 'Format de mot de passe invalide',
        'Invalid phone number format': `Format de numéro de téléphone invalide. Veuillez utiliser un format +12345678900`,
        'Loading...': 'Chargement...',
        'Lost your code? ': 'Vous avez perdu votre code ? ',
        'Network error': 'Erreur réseau',
        'New Password': 'Nouveau mot de passe',
        'No account? ': 'Pas de compte ? ',
        'or': 'ou',
        'Password': 'Mot de passe',
        'Phone Number': 'Numéro de téléphone',
        'Resend a Code': 'Renvoyer un code',
        'Resend Code': 'Renvoyer le code',
        'Reset password': 'Réinitialisez votre mot de passe',
        'Reset your password': 'Réinitialisez votre mot de passe',
        'Send': 'Envoyer',
        'Send Code': "M'envoyer un code",
        'Send code': "M'envoyer un code",
        'Sign in': 'Se connecter',
        'Sign In': 'Se connecter',
        'Sign in to your account': 'Connexion à votre compte',
        'Sign In with Amazon': 'Se connecter avec Amazon',
        'Sign In with AWS': 'Se connecter avec AWS',
        'Sign In with Facebook': 'Se connecter avec Facebook',
        'Sign In with Google': 'Se connecter avec Google',
        'Sign Out': 'Déconnexion',
        'Sign Up': "S'inscrire",
        'Skip': 'Passer',
        'SMS': 'SMS',
        'Submit': 'Soumettre',
        'Signing in': 'Connexion',
        'Invalid code received for user': 'Code invalide',
        'Setup TOTP': 'Configuration TOTP',
        'Your passwords must match': 'Vos mots de passe doivent correspondre',
        'User already exists': "L'utilisateur existe déjà",
        'User does not exist': "L'utilisateur n'existe pas",
        'Username': "Nom d'utilisateur",
        'Username cannot be empty': "Le nom d'utilisateur doit être renseigné",
        'Username/client id combination not found.': "L'utilisateur n'existe pas",
        'Verify': 'Vérifier',
        'Verify Contact': 'Vérifier le contact',
        "cookieconsent": "Nous utilisons les cookies afin de fournir les services et fonctionnalités proposés sur notre site et afin d’améliorer l’expérience de nos utilisateurs. Les cookies sont des données qui sont téléchargés ou stockés sur votre ordinateur ou sur tout autre appareil. En poursuivant votre navigation sur ce site, vous en acceptez l’utilisation.",
        "cookieaccept": "J'accepte",
        "account": "Mon profil",
        "logout": "Déconnexion",
        "My CdM": "My CdM",
        "currentlanguage": "fr",
        "Apprenti": "Apprenti",
        "Organisme de formation": "Organisme de formation",
        "Tuteur": "Patron",
        "Évaluation de l'apprenti": "Évaluation de l'apprenti",
        "Unité capitalisable": "Unité capitalisable",
        "Module": "Module",
        "Méthode(s) d'évaluation prescrite(s)": "Méthode(s) d'évaluation prescrite(s)",
        "Compétences": "Compétences",
        "Indicateurs": "Indicateurs",
        "Socles": "Socles",
        "Points acquis": "Points acquis",
        "Justification en cas de note insuffisante(< 50% des points max.)": "Justification en cas de note insuffisante(< 50% des points max.)",
        "Justification en cas de compétence non-évaluée": "Justification en cas de compétence non-évaluée",
        "Module non-évalué": "Module non-évalué",
        "Compétence non-évaluée": "Compétence non-évaluée",
        "Justification": "Justification",
        "Annuler": "Annuler",
        "Brouillon": "Brouillon",
        "Valider": "Valider",
        "Retour": "Retour",
        "Signature": "Signature",
        "Date et cachet de l'organisme de formation": "Date et cachet de l'organisme de formation",
        "ValidatedAndTransfered": "Validée et transmise par l'organisme de formation le ",
        "AcceptAndSign": "En cochant cette case, je valide définitvement cette grille d'évaluation et accepte qu'elle soit transmise au service Formation Initiale de la Chambre des Métiers.",
        "Succès": "Succès",
        "Brouillon sauvegardé": "Brouillon sauvegardé",
        "Grille validée": "Grille validée",
        "Grille d'évaluation du module en organisme de formation": "Grille d'évaluation du module en organisme de formation",
        "Apprentissage": "Apprentissage",
        "Nombre d'apprentis": "Nombre d'apprentis",
        "Mes labels": "Mes labels",
        "Nombre de labels": "Nombre de labels",
        "Justification en cas de module non-évalué": "Justification en cas de module non-évalué",
        "Informations importantes": "Informations importantes",
        "Mes évaluations": "Mes évaluations",
        "Module warning": "Les modules doivent être évalués entièrement avant la fin du semestre dans lequel ils sont prévus. Dans des cas exceptionnels et motivés, le résultat d'un module patronal peut être introduit à la fin de l'année scolaire dans laquelle il a été organisé.",
        "Competence warning": "Si une compétence n’a pas pu être évalué, le module entier est automatiquement non évalué et à évaluer entièrement lors du semestre suivant.",
        "profile": "Mon profil",
        "gerants": "Gérant",
        "certified": "Certifié",
        "tuteurs": "Patrons",
        "delegue": "Gestionnaire de compte",
        "superviseurs_apprentissage": "Superviseur Apprentissage",
        "Welcome": "Bienvenue",
        "passwordpolicy": "Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un caractère spécial ^ $ * . [ ] { } ( ) ? - \" ! @ # % & / \\ , ' : ; | _ ~ ` et un chiffre",
        "statut": "Statut",
        "error": "Erreur",
        "noContact": "Veuillez ajouter un contact",
        "yes": "Oui",
        "no": "Non",
        "print": "Imprimer",
        "confirm": "Confirmation",
        "filtrer": "Filtrer",
        "byUser": " par l'utilisateur ",
        "phone_number": "GSM",
        "invalideFormat": "Utilisez le format +352123456 (indicatif du pays correspondant)",

        //SCRB
        "new": "Nouvelle",
        "numero": "Numéro",
        "genreInstallation": "Genre",
        "installateur": "Installateur",
        "emplacement": "Emplacement",
        "specifications": "Spécifications",
        "chaudiere": "Chaudière",
        "bruleur": "Brûleur",
        "back": "Précedent",
        "next": "Suivant",
        "newInstallation": "Nouvelle installation",
        "selectGenreInst": "Sélectionner le combustible",
        "rechercheAdresse": "Recherche d'adresse",
        "utilisateur": "Utilisateur",
        "proprietaire": "Propriétaire",
        "ownerSame": "Propriétaire identique à l'utilisateur ",
        "owner": "Propriétaire",
        "nom": "Nom",
        "mail": "Email",
        "tel": "Téléphone",
        "number": "Numéro",
        "street": "Rue",
        "codePostal": "Code postal",
        "localite": "Localité",
        "dateDemande": "Date demande",
        "localEmplacement": "Emplacement local",
        "typeBatiment": "Type de bâtiment",
        "etage": "Etage (installation)",
        "specification": "Spécification",
        "batiment": "Bâtiment",
        "nbEtages": "Nombre d'étages",
        "typeCondenseur": "Type condenseur",
        "typeEvaporateur": "Type evaporateur",
        "utilisation": "Utilisation",
        "typeFluide": "Type Fluide",
        "fluideCaloporteur": "Fluide caloporteur",
        "chaudAppareil": "Appareil",
        "appareil": "Appareil",
        "donneesTechniques": "Données techniques",
        "contactNom": "Contact",
        "contactNace": "Contact Nace",
        "marqueChaudiere": "Marque",
        "modelChaudiere": "Modèle",
        "anneeConstructChaudiere": "Année de construction",
        "anneeEntreeChaudiere": "Année de mise en service",
        "chargeNominale": "Charge nominale",
        "puissanceFrigo": "Puissance frigorifique",
        "puissanceElec": "Puissance électrique",
        "country": "Pays",
        "typeInstallation": "Type installation",
        "puissanceChaudiere": "Puissance",
        "puissanceMinChaudiere": "Puissance Min. chaudière",
        "puissanceMaxChaudiere": "Puissance Max. chaudière",
        "puissanceMinBruleur": "Puissance Min. brûleur",
        "puissanceMaxBruleur": "Puissance Max. brûleur",
        "marqueBruleur": "Marque brûleur",
        "modelBruleur": "Modèle brûleur",
        "anneeConstructBruleur": "Année de construction",
        "anneeEntreeBruleur": "Année de mise en service",
        "typeBruleur": "Type brûleur",
        "typeChaudiere": "Type chaudière",
        "copyData": "Copier",
        "address": "Adresse",
        "anneeRenovBatiment": "Année de construction ou de rénovation",
        "typePompe": "Type de pompe à chaleur",
        "chargeChauffageBatiment": "Charge de chauffage du batiment à la température de référence (KW)",
        "puissanceNecessaireEauChaude": "Puissance nécessaire pour l'eau chaude (kW)",
        "surfaceRefEnergitique": "Surface de référence énergétique (m²)",
        "qteRemplissageRefrigerant": "Quantité de remplissage du réfrigérant (KG)",
        "modeFonctionnementPompe": "Mode de fonctionnement",
        "puissanceResistance": "Puissance de la résistance (KW)",
        "puissanceDeuxiemeGenerateur": "Puissance deuxième générateur (KW)",
        "puissanceSelonNorme": "Puissance selon EN14511 ou EN14825 au point de dimensionnement",
        "noInstallation": "Aucune installation trouvée",
        "reference": "Référence",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "genreReception": "Genre réception",
        "send": "Envoyer",
        "reception": "Réception",
        "tournees": "Tournées",
        "tournee": "Tournée",
        "demandeReception": "Demande de réception",
        "installationsEnCours": "Installations en cours",
        "nonDemande": "Non demandée",
        "nonPlanifie": "Non planifiée",
        "nonConfirme": "Non confirmée",
        "confirme": "Confirmée",
        "facture": "Facturée",
        "errorValidation": "Veuillez corriger les champs en rouge",
        "filtre": "Filtres",
        "combustible": "Combustible",
        "listeInstallations": "Installations : ",
        "manageTournee": "Gestion de la tournée",
        "addReception": "Ajouter une réception",
        "confirmRemoveReception": "Voulez-vous supprimer ce rendez-vous ?",
        "delete": "Supprimer",
        "aucuneTournee": "Aucune tournée trouvée",
        "searchRef": "Rechercher un numéro / Client / Ville",
        "listeCoffrets": "Liste des coffrets de mesure pour ",
        "codeCoffret": "Code",
        "cMarque": "Marque coffret",
        "pMarque": "Marque pompe à huile",
        "modele": "Modèle coffret",
        "numeroSerie": "Numéro de série",
        "coffret": "Coffret",
        "agreeMazout": "Agréé pour Mazout",
        "agreeGaz": "Agréé pour Gaz",
        "actif": "Actif",
        "horsService": "Hors service",
        "controlOrg": "Organisme de contrôle",
        "o2zb": "O2 - zone basse",
        "o2ze": "O2 - zone élevée",
        "cozb": "CO - zone basse",
        "coze": "CO - zone élevée",
        "tempzb": "Température - zone basse",
        "tempze": "Température - zone élevée",
        "pompeSui": "Pompe à suie",
        "deprimometre": "Déprimomètre",
        "echelleGris": "Echelle des gris",
        "sondeMtrous": "Sonde multis-trous",
        "sondeEspaceA": "Sonde pour espace annulaire",
        "miroir": "Miroir avec poignée",
        "indRefoulement": "Indicateur de refoulement",
        "supportSonde": "Support sonde",
        "endoscope": "Endoscope",
        "resultat": "Résultat",
        "remarque": "Remarque",
        "dernierControle": "Dernier contrôle du",
        "donneesCoffret": "Données techniques",
        "controlOrg1": "Service technique de l’inspection des cheminées de Trèves",
        "controlOrg2": "Service technique de l’inspection des cheminées de la Sarre",
        "aggreation": "Agréé pour",
        "noReceptionAvailable": "Aucune réception trouvée",
        "noInstallationAvailable": "Aucune installation trouvée",
        "confirmValideTournee": "Voulez-vous vraiment confirmer cette tournée ?",
        "validate": "Confirmer",
        "bruleurSame": "Brûleur identique",
        "details": "Détails",
        "date": "Date",
        "status": "Status",
        "controleur": "Contrôleur",
        "coffrets": "Coffrets de mesure",
        "all": "Tous",
        "search": "Rechercher",
        "firstAppointment": "Premier rendez-vous",
        "prixBiomasse": "Installation combustible solide",
        "prixClim": "Installation frigorifique",
        "prixMazout1": "Installation au gasoil: brûleur à allures ou modulant",
        "prixMazout2": "Installation au gasoil: brûleur mixte",
        "prixGaz": "Installation au gaz",
        "prixPompe": "Pompe à chaleur",
        "horsTaxes": "Hors taxes",
        "prixPratique": "Tarifs",
        "reglements": "Règlements",
        "outils": "Outils",
        "informations": "Informations",
        "addressDeContact": "Adresses mail qui recevront les notifications des mises à jour de tournée",
        "add": "Ajouter",
        "confirmRemoveContact": "Voulez-vous vraiment supprimer ce contact ?",
        "contactDeleted": "Contact supprimé",
        "success": "Succès",
        "addContact": "Ajouter un contact (email)",
        "contactNotDeleted": "Contact non supprimé",
        "contactAdded": "Contact ajouté",
        "contactNotAdded": "Contact non ajouté",
        "tourneeNotSaved": "Erreur lors de la sauvegarde de la tournee",
        "scrb": "SCRB",
        "welcome": "Bienvenue sur l'extranet de la Chambre de Métiers",
        "mesTournees": "Mes tournées",
        "mesCoffrets": "Mes coffrets",
        "mesInstallations": "Mes installations",
        "tourneeFull": "La tournée est pleine",
        "historique": "Historique",
        "passee": "Passée",
        "avenir": "À venir",
        "reglementgaz": "Règlement installation à gaz",
        "infosDonneesMazout": "Traitement des données pour le mazout",
        "moderniserPompe": "Guide pratique des systèmes de pompe à chaleur",
        "reglementsolide": "Règlement installation à combustible solide ou liquide",
        "reglementfrigo": "Règlement installation climatisation",
        "reglementPompe": "Règlement installation pompe à chaleur",
        "ameneeAirComb": "Calcul d'amenée d'air",
        "dimensionnementGaz": "Dimensionnement et des conduites de gaz",
        "downloads": "Téléchargements",
        "addContactHelp": "Ajouter une adresse qui recevra les notifications des tournée",
        "deleteContactHelp": "Supprimer une adresse mail",
        "prixPratiqueHelp": "Tarifs pratiqués pour les installations de chauffage, de climatisation et de pompe à chaleur",
        "reglementsHelp": "Règlements grand ducal et informations diversespour les installations de chauffage, de climatisation et de pompe à chaleur",
        "clickDownload": "Cliquez sur le fichier pour télécharger les documents",
        "outilsHelp": "Outils de calculs pour les installations de chauffage, de climatisation et de pompe à chaleur",
        "newInstallationHelp": "Ajouter une nouvelle installation",
        "printInstallationHelp": "Imprimer la liste des installations affichées, en tenant compte des filtres appliqués",
        "searchHelp": "Rechercher une installation avec une adresse, un nom, une réference",
        "selectInstallationHelp": "Sélectionner une installation",
        "searchTourneeHelp": "Rechercher une tournée avec un nom, une date, une adresse, une référence",
        "selectTourneeHelp": "Sélectionner une tournée",
        "modifyTourneeHelp": "Modifier le contenu ou l'ordre des rendez-vous d'une tournée",
        "validateTourneeHelp": "Confirmer la tournée, elle n'est plus modifiable",
        "detailsTourneeHelp": "Après confirmation, permet de voir les détails d'une tournée",
        "moveMeetingHelp": "Drag & Drop pour déplacer un rendez-vous",
        "deleteMeetingHelp": "Supprimer un rendez-vous",
        "addMeetingHelp": "Ajouter un rendez-vous, liste des installations non planifiées",
        "saveTourneeHelp": "Enregistrer la tournée, le nouveau planning est proposé au SCRB",
        "cancelTourneeHelp": "Annuler les modifications effectuées, retour à l'écran précédent",
        "infosAddMeeting": "Le nombre de rendez est limité en fonction du type de combustible",
        "manageInstallation": "Gestion de l'installation",
        "saveInstallationHelp": "Enregistrer l'installation, le nouveau planning est proposé au SCRB",
        "cancelInstallationHelp": "Annuler les modifications effectuées et les données saisies, retour à l'écran précédent",
        "printManageInstallationHelp": "Imprimer la fiche de l'installation.",
        "printPdfHelp":"Pour générer un PDF, choisir l'imprimante « Microsoft Print to PDF » ou « Save as PDF »",
        "installations": "Installations",
        "certificatsGaz": "Certificats de conformité",
        "titreCertifGaz": "Certificat de Conformité des conduites de Gaz",
        "certifGaz": "Par la présente nous certifions que l'installation en question a subi avec succès l'épreuve d'étanchéité et est conforme aux dispositions du règlement grand-ducal du 27 février 2010 relatif aux installations de combustion alimentées en gaz.",
        "titreCertifFume": "Certificat de Conformité du système d'évacuation des fumées",
        "certifFume1": "Par la présente nous certifions que l'installation en question dispose d'un système d'évacuation des fumées et est conforme aux dispositions du règlement grand-ducal du 27 février 2010 relatif aux installations de combustion alimentées en gaz.",
        "certifFume2": "Un certificat de conformité relatif au système d'évacuation de fumées a été établi par le fumiste agréé",
        "certifFumiste": "Nom du fumiste",
        "conformite": "Conformité",
        "conforme": "Conforme",
        "nonConforme": "Non conforme",
        "addressTooltip": "Saisissez une adresse valide. Si elle n'est pas reconnue, veuillez saisir le numéro ainsi que la rue.",
        "help": "Aide",
        "facturation": "Facturation",
        "numCommandeClient": "Mon numéro de commande",
        "aggreationCE": "Agréation CE",
        "nouveauRdv": "Nouveau rendez-vous",
        "pasDeControle": "Aucun contrôle",
        "numSerie": "Numéro de série",
        "laboratoires": "Laboratoires aggréés",
        "gsm": "GSM",
        "fax": "Fax",
        "email": "E-Mail",
        "site": "Website",
        "directeurLabo": "Directeur de laboratoire",
        "warning": "Attention",
        "secretaire": "Secrétaire",
        "contacts": "Contacts",
        "jaccepte": "J'accepte les",
        "conditionsUtilisation": " conditions d'utilisation « Extranet eSCRB »",
        "linkConditionsUtilisation": "https://scrb.cdm.lu/conditions-dutilisation",
        "confirmAddress": "Vérifiez l'exactitude de l'adresse trouvée ! (code postal, localité, etc...)",
        "nbRdv": "Nombre de rendez-vous",
        "textPompe": "Les pompes à chaleur mises en service après le 19 septembre 2025 sont soumises à la nouvelle règlementation grand-ducale et doivent être saisies sous Pompe à chaleur.",
        "responsableNom": "Nom du responsable chantier",
        "Extranet User with same mail detected": "Un utilisateur avec le même email existe déjà",
        "delegue_tooltip": "Compte possédant les mêmes droits que le gérant. Permet de créer d'autres utilisateurs.",
        "delegue_compte": "Permet au gérant de déléguer la gestion des comptes utilisateurs.",
        "cgu": "Conditions générales d'utilisation",
        "accepter": "J'accepte",
        "refuser": "Je refuse",
        "mailTooltip": "Adresse utilisée pour l'envoi des protocoles de réception",
        "infoContact": "Adresse utilisée pour recevoir les notifications des mises à jour de tournée ainsi que les protocoles de réception",

        "typeInstallation0": "Non défini",
        "typeInstallation1": "Chauffage",
        "typeInstallation2": "Eau chaude",
        "typeInstallation3": "Chauffage et eau chaude",
        "typeInstallation4": "Chauffage à air",
        "typeInstallation5": "Autre",
        "typeInstallation6": "Climatisation",
        "typeInstallation7": "Pompe à chaleur",
        "typeCombustible1": "Gasoil",
        "typeCombustible2": "Fuel lourd",
        "typeCombustible3": "Huiles usagées",
        "typeCombustible4": "Gaz naturel",
        "typeCombustible5": "Gaz liquéfié",
        "typeCombustible6": "Récipient fixe",
        "typeCombustible7": "Récipient mobiles",
        "typeCombustible8": "Charbon de bois (1)",
        "typeCombustible9": "Briquettes de charbon de bois (1)",
        "typeCombustible10": "Briquettes de lignite (1)",
        "typeCombustible11": "Briquettes de houille (1)",
        "typeCombustible12": "Anthracite (1)",
        "typeCombustible13": "Briquettes de tourbe (2)",
        "typeCombustible14": "Bûches de bois (3)",
        "typeCombustible15": "Plaquettes de bois (3)",
        "typeCombustible16": "Brindilles de bois (3)",
        "typeCombustible17": "Copeaux (3)",
        "typeCombustible18": "Sciures de bois (4)",
        "typeCombustible19": "Sciures de bois (4)",
        "typeCombustible20": "Ecorce (4)",
        "typeCombustible21": "Comprimés de bois - briquettes (5)",
        "typeCombustible22": "Comprimés de bois - pellets (5)",
        "typeCombustible23": "Pailles ou autres substances végétales (6)",
        "typeCombustible24": "Comprimés à base de pailles ou d'autres substances végétales (6)",
        "typeBatiment0": "<non défini>",
        "typeBatiment1": "Maison unifamiliale",
        "typeBatiment2": "Maison d'appartements",
        "typeBatiment3": "Bâtiment administratif",
        "typeBatiment4": "Commerce",
        "typeBatiment5": "Industrie",
        "typeBatiment6": "Autre",
        "typeCondenseur0": "à définir",
        "typeCondenseur1": "Condenseur fluide réfrigérant/air",
        "typeCondenseur2": "Condenseur fluide réfrigérant/eau",
        "typeEvaporateur0": "à définir",
        "typeEvaporateur1": "Evaporateur fluide réfrigérant/air",
        "typeEvaporateur2": "Evaporateur fluide réfrigérant/eau",
        "utilisation0": "à définir",
        "utilisation1": "Réfrigération (température positive)",
        "utilisation2": "Climatisation",
        "utilisation3": "Congélation (température négative)",
        "typeChaudiere1": "Chaudière atmosphérique",
        "typeChaudiere2": "Chaudière spéciale",
        "typeChaudiere3": "Chaudière mixte",
        "typeChaudiere4": "Chaudière à condensation",
        "typeChaudiere5": "Brûleur à air pulsé",
        "typeChaudiere6": "Chauffe eau à gaz",
        "typeChaudiere7": "Chauffe-eau instantané à gaz",
        "typeChaudiere8": "Chauffe-eau à gaz à accumulation",
        "typeChaudiere9": "Appareils à gaz à double service chauffage/eau",
        "typeChaudiere10": "Chauffe-eau à gaz à circuit étanche",
        "typeChaudiere11": "Poêle à gaz",
        "typeChaudiere12": "Radiateur à convection",
        "typeChaudiere13": "Générateur d'air chaud à gaz",
        "typeChaudiere14": "Installation de cogénération p. élect. < à 100 kW",
        "typeChaudiere15": "Chaudière simple",
        "typeChaudiere16": "Chaudière à condensation",
        "typeChaudiere17": "Chaudière combinée",
        "typeChaudiere18": "Chauffage de locaux raccordé",
        "typeChaudiere19": "Fourneau de chauffage central raccordé",
        "typeChaudiere20": "Insert de cheminée fermée raccordée",
        "typeChaudiere21": "Chaudière à lit fluidisé",
        "typeChaudiere22": "Chaudière à condensation",
        "typeChaudiere23": "Chaudière spéciale",
        "typeChaudiere24": "Air/Eau en intérieur",
        "typeChaudiere25": "Air/Eau en extérieur",
        "typeChaudiere26": "Géothermie",
        "typeChaudiere27": "Air/Air",
        "typeChaudiere28": "Autres",
        "typeBruleur0": "à définir",
        "typeBruleur1": "Brûleur à 1 allure",
        "typeBruleur2": "Brûleur à 2 allures",
        "typeBruleur3": "Brûleur mixte",
        "typeBruleur4": "Brûleur modulant",
        "typeBruleur5": "Brûleur à 3 allures",
        "modeFonctionnementPompe1": "Monovalent",
        "modeFonctionnementPompe2": "Monoénergetique",
        "modeFonctionnementPompe3": "Bivalente",
        "genreReception0": "Non défini",
        "genreReception1": "Nouvelle installation",
        "genreReception2": "Transformation brûleur",
        "genreReception3": "Transformation chaudière",
        "genreReception4": "Transf. chaud. + brûl.",
        "genreReception5": "Installation existante",
        "scrb_mazout": "Mazout",
        "scrb_gaz": "Gaz",
        "scrb_clim": "Climatisation",
        "scrb_solide": "Solide",
        "scrb_pompe_chaleur": "Pompe à chaleur",
        "Mazout": "Mazout",
        "Gaz": "Gaz",
        "Fluide réfrigérant": "Clim",
        "Combustible solide": "Solide",
        "Pompe à chaleur": "Pompe",
    },
    de: {
        'Account recovery requires verified contact information':
            'Zurücksetzen des Account benötigt einen verifizierten Account',
        'An account with the given email already exists.':
            'Ein Account mit dieser Email existiert bereits.',
        'Back to Sign In': 'Zurück zur Anmeldung',
        'Change': 'Ändern',
        'Change Password': 'Passwort ändern',
        'Code': 'Code',
        'Confirm': 'Bestätigen',
        'Confirm Password': 'Passwort bestätigen',
        'Confirm a Code': 'Code bestätigen',
        'Confirm Sign In': 'Anmeldung bestätigen',
        'Confirm Sign Up': 'Registrierung bestätigen',
        'Confirm SMS Code': 'SMS-Code bestätigen',
        'Confirm TOTP Code': 'TOTP-Code bestätigen',
        'Confirmation Code': 'Bestätigungs-Code',
        'Create a new account': 'Einen neuen Account erstellen',
        'Create account': 'Hier registrieren',
        'Create Account': 'Account erstellen',
        'Creating Account': 'Account wird erstellt',
        'Email': 'Email',
        'Enter your code': 'Geben Sie Ihren Code ein',
        'Enter your password': 'Geben Sie Ihr Passwort ein',
        'Enter your username': 'Geben Sie Ihren Benutzernamen ein',
        'Enter your phone number': 'Geben Sie Ihre Telefonnummer ein',
        'Enter your email': 'Geben Sie ihre Email ein',
        'Forgot your password?': 'Passwort vergessen? ',
        'Forgot Password': 'Passwort vergessen',
        'Hide password': 'Passwort verbergen',
        'Have an account? ': 'Schon registriert? ',
        'Incorrect username or password.':
            'Falscher Benutzername oder falsches Passwort',
        'Invalid password format': 'Ungültiges Passwort-Format',
        'Invalid phone number format': `Ungültiges Telefonummern-Format. Benutze eine Nummer im Format: +12345678900`,
        'Lost your code? ': 'Code verloren? ',
        'New Password': 'Neues Passwort',
        'No account? ': 'Kein Account? ',
        'or': 'oder',
        'Password': 'Passwort',
        'Password attempts exceeded':
            'Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht',
        'Phone Number': 'Telefonnummer',
        'Resend Code': 'Code erneut senden',
        'Reset password': 'Passwort zurücksetzen',
        'Reset your password': 'Zurücksetzen des Passworts',
        'Send Code': 'Code senden',
        'Send code': 'Code senden',
        'Sign in': 'Anmelden',
        'Sign In': 'Anmelden',
        'Sign in to your account': 'Melden Sie sich mit Ihrem Account an',
        'Sign Out': 'Abmelden',
        'Sign Up': 'Registrieren',
        'Skip': 'Überspringen',
        'Submit': 'Abschicken',
        'Signing in': 'Anmeldung',
        'Invalid code received for user': 'Ungültiger Code',
        'Setup TOTP': 'TOTP Konfiguration',
        'Your passwords must match': 'Ihre Passwörter müssen übereinstimmen',
        'User already exists': 'Dieser Benutzer existiert bereits',
        'User does not exist': 'Dieser Benutzer existiert nicht',
        'Username': 'Benutzername',
        'Username cannot be empty': 'Benutzername darf nicht leer sein',
        'Verify': 'Verifizieren',
        'Verify Contact': 'Kontakt verifizieren',
        "cookieconsent": "Wir verwenden Cookies, um die auf unserer Website angebotenen Dienste und Funktionen bereitzustellen und die Erfahrung unserer Benutzer zu verbessern. Cookies sind Daten, die heruntergeladen oder auf Ihrem Computer oder einem anderen Gerät gespeichert werden. Durch das weitere Surfen auf dieser Website akzeptieren Sie deren Verwendung.",
        "cookieaccept": "Ich nehme an",
        "account": "Mein Benutzerprofil",
        "logout": "Ausloggen",
        "My CdM": "My CdM",
        "Évaluations": "Bewertungen",
        "currentlanguage": "de",
        "Apprenti": "Lehrling",
        "Organisme de formation": "Ausbildungsbetrieb",
        "Tuteur": "Geschäftsführer",
        "Évaluation de l'apprenti": "Lehrlingsbewertung",
        "Unité capitalisable": "Baustein",
        "Module": "Modul",
        "Méthode(s) d'évaluation prescrite(s)": "Vorgeschriebene Evaluierungsmethode(n)",
        "Compétences": "Kompetenzen",
        "Indicateurs": "Indikatoren",
        "Socles": "Standards",
        "Points acquis": "erreichte Punkte",
        "Justification en cas de note insuffisante(< 50% des points max.)": "Begründung der ungenügenden Punktzahl (< 50% der max. Punkte)",
        "Justification en cas de compétence non-évaluée": "Begründung im Falle einer nicht bewerteten Kompetenz",
        "Module non-évalué": "Modul nicht bewertet",
        "Compétence non-évaluée": "Kompetenz nicht bewertet",
        "Justification": "Begründung",
        "Annuler": "Abbrechen",
        "Brouillon": "Entwurf",
        "Valider": "Bestätigen",
        "Retour": "Zurück",
        "Signature": "Unterschrift",
        "Date et cachet de l'organisme de formation": "Datum und Stempel des Ausbildungsbetriebes",
        "ValidatedAndTransfered": "Bestätigt und übermittelt durch die Ausbildungseinrichtung am ",
        "AcceptAndSign": "Mit dem Ankreuzen dieses Kästchen, bestätige ich dieses Evaluierungsraster und stimme zu, dass es an die Abteilung der Erstausbildung der Chambre des Métiers übermittelt wird.",
        "Succès": "Erfolg",
        "Brouillon sauvegardé": "Gespeicherter Entwurf",
        "Grille validée": "Validiertes Bewertungsraster",
        "Grille d'évaluation du module en organisme de formation": "Bewertungsraster des Moduls in einer Ausbildungsbetrieb",
        "Apprentissage": "Ausbildung",
        "Nombre d'apprentis": "Anzahl an Lehrlinge",
        "Mes labels": "Meine labels",
        "Nombre de labels": "Anzahl an Label",
        "Justification en cas de module non-évalué": "Begründung im Falle eines nicht bewerteten Moduls",
        "Informations importantes": "Wichtige Hinweise",
        "Mes évaluations": "Meine Bewertungen",
        "Module warning": "Die Evaluierung der Module muss spätestens bis zum Ende des vorgesehenen Semesters erfolgen. In begründeten Ausnahmefällen kann das Resultat eines Moduls erst am Ende des Ausbildungsjahres, in dem es organisiert wurde, vorgelegt werden.",
        "Competence warning": "Falls eine Kompetenz nicht evaluiert werden konnte, gilt das gesamte Modul automatisch als nicht bestanden und muss nochmal vollständig im nächsten Semester evaluiert werden.",
        "profile": "Profil",
        "gerants": "Manager",
        "certified": "Zertifiziert",
        "tuteurs": "Geschäftsführer",
        "delegue": "Account Manager",
        "superviseurs_apprentissage": "Lernbetreuer",
        "Informations personnelles": "Persönliche Informationen",
        "Nom d'utilisateur": "Benutzername",
        "Nom": "Name",
        "Prénom": "Vorname",
        "eMail": "eMail",
        "Email déjà utilisé": "Bereits verwendete E-Mail",
        "Français": "Französisch",
        "Allemand": "Deutsch",
        "Sauvegarder": "Speichern",
        "Equipe": "Team",
        "ACTIF": "AKTIV",
        "DÉSACTIVÉ": "DEAKTIVIERT",
        "Modifier l'utilisateur": "Benutzer ändern",
        "Désactiver l'utilisateur": "Benutzer deaktivieren",
        "Activer l'utilisateur": "Benutzer aktivieren",
        "Voulez-vous activer": "Möchten Sie aktivieren",
        "Voulez-vous désctiver": "Möchten Sie deaktivieren",
        "Oui": "Ja",
        "Non": "Nein",
        "Statut": "Status",
        "Rôles": "Rollen",
        "Vos entreprises": "Ihre Unternehmen",
        "Merci de sélectionner une entreprise": "Bitte wählen Sie ein Unternehmen aus",
        "Tous les utilisteurs ont accès": "Alle Nutzer haben Zugriff",
        "Utilisateur": "Benutzer",
        "Ou": "Oder",
        "Nom d'utilisateur déjà attribué": "Bereits vergebener Benutzername",
        "Langue préférée": "Bevorzugte Sprache",
        "Permissions": "Berechtigungen",
        "Ajout d'un membre": "Mitglied hinzufügen",
        "Gérer mon équipe": "Team verwalten",
        "Actions possibles": "Mögliche Aktionen",
        "Ajouter des nouveaux membres à votre équipe": "Neue Mitglieder zu Ihrem Team hinzufügen",
        "Modifier les membres de votre équipe": "Bearbeiten von Teammitgliedern",
        "Activer l'accès des membres de votre équipe": "Zugriff für Teammitglieder aktivieren",
        "Désactiver l'accès des membres de votre équipe": "Zugriff der Teammitglieder deaktivieren",
        "Données affichées": "Angezeigte Daten",
        "Le nom utilisé pour se connecter": "Der Name, mit dem man sich anmeldet",
        "Le nom de l'utilisateur": "Der Name des Benutzers",
        "Le prénom de l'utilisateur": "Vorname des Benutzers",
        "Statut du compte de l'utilisateur": "Status des Benutzerkontos",
        "Le rôle joué par l'utilisateur": "Die Rolle, die der Benutzer spielt",
        "Nouvel utilisateur": "Neuer Benutzer",
        "Gestion des membres": "Mitglieder verwalten",
        "Cet écran vous permet d'ajouter ou de modifier des utilisateurs au sein de votre équipe et de leur accorder certaines permissions:": "Auf diesem Bildschirm können Sie Benutzer in Ihrem Team hinzufügen oder bearbeiten und ihnen bestimmte Berechtigungen erteilen:",
        "Permet d'accèder à la partie apprentissage, évaluation des apprentis.": "Ermöglicht den Zugang zum Lehrlingsteil, Lehrlingsbewertung.",
        "Si vous êtes gérants de plusieurs entreprises, il vous est possible de réutiliser un compte utilisateur de celles-ci.": "Wenn Sie Geschäftsführer mehrerer Unternehmen sind, ist es möglich, ein Benutzerkonto aus diesen Unternehmen wiederzuverwenden",
        "Besoin d'aide?": "Benötigen Sie Hilfe",
        "Cliquez ": "Klicken Sie ",
        "ici": "hier",
        " pour consulter la vidéo explicative.": " um sich das Erklärvideo anzusehen.",
        "Vidéo explicative": "Erklärvideo",
        "Aide": "Hilfe",
        "Aide globale": "Allgemeine Hilfe",
        "Retrouvez ici tous les liens vers les différentes aides:": "Hier finden Sie alle Links zu den verschiedenen Hilfen:",
        "https://www.cdm.lu/mediatheque/media/comment-realiser-ma-premiere-connexion": "https://www.cdm.lu/mediatheque/media/wie-melde-ich-mich-das-erste-mal-an",
        "https://www.cdm.lu/mediatheque/media/ou-trouver-mon-code-de-verification": "https://www.cdm.lu/mediatheque/media/wo-finde-ich-meinen-bestaetigungscode",
        "https://www.cdm.lu/mediatheque/media/comment-ajouter-un-tuteur-a-mon-equipe": "https://www.cdm.lu/mediatheque/media/wie-fuege-ich-einen-lernbetreuer-hinzu",
        "https://www.cdm.lu/mediatheque/media/comment-gerer-mon-equipe": "https://www.cdm.lu/mediatheque/media/wie-verwalte-ich-meine-mannschaft",
        "Welcome": "Willkommen",
        "passwordpolicy": "Das Passwort muss mindestens 8 Zeichen enthalten, Großbuchstaben, Kleinbuchstaben, Sonderzeichen ^ $ * . [ ] { } ( ) ? - \" ! @ # % & / \\ , ' : ; | _ ~ ` und eine Zahl",
        "filtre": "Filter",
        "statut": "Statut",
        "searchRef": "Suche nach Nummer / Client / Ort",
        "error": "Fehler",
        "noContact": "Bitte einen Kontakt hinzufügen",
        "yes": "Ja",
        "no": "Nein",
        "print": "Drucken",
        "confirm": "Bestätigen",
        "filtrer": "Filter",
        "help": "Hilfe",
        "facturation": "Rechnung",
        "numCommandeClient": "Mein Bestellnummer",
        "byUser": " vom Benutzer ",
        "phone_number": "GSM",
        "invalideFormat": "Verwenden Sie das Format +352123456 (Ländercode)",
        "gsm": "GSM",
        "fax": "Fax",
        "email": "E-Mail",
        "site": "Website",
        "contacts": "Kontakten",


        //SCRB
        "new": "Neu",
        "numero": "Nummer",
        "genreInstallation": "Genre",
        "installateur": "Installateur",
        "emplacement": "Lage",
        "specifications": "Spezifikationen",
        "chaudiere": "Heizung",
        "bruleur": "Flammenhalter",
        "back": "Zurck",
        "dateDemande": "Datum der Anfrage",
        "next": "Weiter",
        "newInstallation": "Neue Installation",
        "selectGenreInst": "Brennstoff auswählen",
        "rechercheAdresse": "Adresse suchen",
        "utilisateur": "Benutzer",
        "proprietaire": "Eigentümer",
        "ownerSame": "Besitzer identisch mit dem Benutzer",
        "owner": "Eigentümer",
        "nom": "Name",
        "mail": "Email",
        "tel": "Telefonnummer",
        "number": "Nummer",
        "street": "Strabe ",
        "codePostal": "Postleitzahl",
        "localite": "Ortschaft",
        "typeBatiment": "Gebäudeart",
        "localEmplacement": "Aufstellraum",
        "etage": "Stock (installation)",
        "nbEtages": "Anzahl der Stockwerke",
        "specification": "Spezifikation",
        "batiment": "Gebäude",
        "typeCondenseur": " Art des Verflüssigers",
        "typeEvaporateur": "Verdampferart",
        "typeFluide": "Art des Kältemittels",
        "fluideCaloporteur": "Wärmeträgerflüssigkeit",
        "utilisation": "Benutzung",
        "chaudAppareil": "Gerät",
        "appareil": "Gerät",
        "donneesTechniques": "technische Daten",
        "contactNom": "Kontaktperson",
        "contactNace": "Kontaktperson Nace",
        "marqueChaudiere": "Marke",
        "modelChaudiere": "Modell",
        "anneeConstructChaudiere": "Baujahr",
        "anneeEntreeChaudiere": "Jahr der Inbetriebnahme",
        "chargeNominale": "Nominelle Kältemittelfüllung",
        "puissanceFrigo": "Kälteleistung/Wärmeleistung",
        "puissanceElec": "Elektrische Leistung",
        "country": "Land",
        "typeInstallation": "Art der Anlage",
        "puissanceChaudiere": "Leistung",
        "puissanceMinChaudiere": "Kleinlast",
        "puissanceMaxChaudiere": "Volllast",
        "puissanceMinBruleur": "Kleinlast",
        "puissanceMaxBruleur": "Volllast",
        "marqueBruleur": "Marke",
        "modelBruleur": "Modell",
        "anneeConstructBruleur": "Baujahr",
        "anneeEntreeBruleur": "Jahr der Inbetriebnahme",
        "typeBruleur": "Brennerart",
        "typeChaudiere": "Heizungsart",
        "copyData": "Kopieren",
        "address": "Adresse",
        "anneeRenovBatiment": "Baujahr des Gebäudes oder der Sanierung",
        "typePompe": "Art der Wärmepumpe",
        "chargeChauffageBatiment": "Heizlast Gebäude bei Auslegungstemperatur (KW)",
        "puissanceNecessaireEauChaude": "Leistungsbedarf Warmwasser (kW)",
        "surfaceRefEnergitique": "Energiebezugsfläche (m²)",
        "qteRemplissageRefrigerant": "Füllmenge des Kältemittels (KG)",
        "modeFonctionnementPompe": "Betriebsweise",
        "puissanceResistance": "Leistung Heizstab (KW)",
        "puissanceDeuxiemeGenerateur": "Leistung zweiter Wärmeerzeuger (KW)",
        "puissanceSelonNorme": "Leistung nach EN14511 oder EN13825 im Auslegungspunkt",
        "noInstallation": "Keine Installation gefunden",
        "reference": "Referenz",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "genreReception": "Art der Abnahme",
        "send": "Senden",
        "reception": "Reception",
        "tournees": "Touren",
        "tournee": "Tour",
        "demandeReception": "Abnahmeanforderung",
        "installationsEnCours": "Laufende Installationen",
        "nonDemande": "Nicht angefragt",
        "nonPlanifie": "Nicht planifiziert",
        "nonConfirme": "Nicht bestätigt",
        "confirme": "Bestätigt",
        "facture": "Rechnung",
        "errorValidation": "Bitte korrigieren Sie die fehlerhaften Felder",
        "combustible": "Brennstoff",
        "listeInstallations": "Einrichtungen : ",
        "manageTournee": "Tourneemanagement",
        "addReception": "Reception hinzufügen",
        "confirmRemoveReception": "Wollen Sie diese Empfänge wirklich löschen?",
        "delete": "Löschen",
        "aucuneTournee": "Keine Tourneen gefunden",
        "listeCoffrets": "Liste der Messkoffer für",
        "coffret": "Messkoffer",
        "codeCoffret": "Code",
        "cMarque": "Marke Box",
        "pMarque": "Marke Ölpumpe",
        "modele": "Modell",
        "numeroSerie": "Nummer",
        "agreeMazout": "Zugelassen für Heizöl",
        "agreeGaz": "Zugelassen für Gas",
        "actif": "Aktiv",
        "horsService": "Hors Service",
        "controlOrg": "Organisme de contrôle",
        "o2zb": "O2 - unteren Bereich",
        "o2ze": "O2 - erhabene Bereich",
        "cozb": "CO - unteren Bereich",
        "coze": "CO - erhabene Bereich",
        "tempZb": "Température - unteren Bereich",
        "tempZe": "Température - erhabene Bereich",
        "pompeSui": "Rußpumpe",
        "deprimometre": "Tiefenmesser",
        "echelleGris": "Graue Skala",
        "sondeMtrous": "Sonde multis-trous",
        "sondeEspaceA": "Multilochsonde",
        "miroir": "Spiegel mit Griff",
        "indRefoulement": "Anzeige der Rückstoßwirkung",
        "supportSonde": "Sondenhalter",
        "endoscope": "Endoskop",
        "resultat": "Ergebnis",
        "remarque": "Kommentar",
        "dernierControle": "Letzte Kontrolle des",
        "donneesCoffret": "technische Daten",
        "controlOrg1": "Technische Prüfstelle der Schornsteinfergerinnung Trier",
        "controlOrg2": "Technische Prüfstelle der Schornsteinfergerin nung Saarland",
        "aggreation": "Zugelassen für",
        "noReceptionAvailable": "Keine Empfänge gefunden",
        "noInstallationAvailable": "Keine Installationen gefunden",
        "confirmValideTournee": "Wollen Sie diese Tourneen wirklich bestätigen?",
        "validate": "Bestätigen",
        "bruleurSame": "Brenner identisch",
        "details": "Details",
        "date": "Datum",
        "status": "Status",
        "controleur": "Kontrolleur",
        "coffrets": "Messkoffer",
        "all": "Alle",
        "search": "Suchen",
        "firstAppointment": "Erster Termin",
        "prixBiomasse": "Festbrennstoffanlage",
        "prixClim": "Kälteanlage",
        "prixMazout1": "Gasöl-Anlage: Brenner mit oder ohne Antrieb",
        "prixMazout2": "Dieselanlage: gemischter Brenner",
        "prixGaz": "Installation mit Gasz",
        "prixPompe": "Wärmepumpe",
        "horsTaxes": "steuerfrei",
        "prixPratique": "Preise",
        "reglements": "Regeln",
        "outils": "Werkzeuge",
        "informations": "Informationen",
        "addressDeContact": "E-Mail-Adressen, die Benachrichtigungen über Touren-Updates erhalten",
        "add": "Hinzufügen",
        "confirmRemoveContact": "Wollen Sie diesen Kontakt wirklich löschen?",
        "contactDeleted": "Kontakt gelöscht",
        "success": "Erfolg",
        "addContact": "Kontakt hinzufügen (email)",
        "contactAdded": "Kontakt hinzugefgt",
        "contactNotAdded": "Kontakt nicht hinzugefgt",
        "tourneeNotSaved": "Fehler beim Speichern der Tour",
        "scrb": "SCRB",
        "welcome": "Willkommen im Extranet der Handwerkskammer",
        "mesTournees": "Meine Tourneen",
        "mesCoffrets": "Meine Messkoffer",
        "mesInstallations": "Meine Einrichtungen",
        "tourneeFull": "Die Tourneen sind voll",
        "historique": "historisch",
        "passee": "vergangenen",
        "a venir": "kommenden",
        "reglementgaz": "Regelung für Gasanlagen",
        "infosDonneesMazout": "Verarbeitung der Daten für Heizöl",
        "moderniserPompe": "Praktischer Leitfaden für Wärmepumpensysteme",
        "reglementsolide": "Regelung für feste oder flüssige Brennstoffe",
        "reglementfrigo": "Regelung für Klimatisierung",
        "reglementPompe": "Regelung für Wärmepumpen",
        "ameneeAirComb": "Berechnung der Luftzufuhr",
        "dimensionnementGaz": "Dimensionierung und Berechnung der Gasrohre",
        "downloads": "Downloads",
        "addContactHelp": "Fügen Sie eine Adresse hinzu, die Benachrichtigungen über Touren erhält",
        "deleteContactHelp": "Eine E-Mail-Adresse löschen",
        "prixPratiqueHelp": "Preise für Heizungs-, Klima- und Wärmepumpenanlagen",
        "reglementsHelp": "Règlements grand ducal und verschiedene Informationen für Heizungs-, Klima- und Wärmepumpenanlagen",
        "clickDownload": "Klicken Sie auf die Datei, um die Dokumente herunterzuladen",
        "outilsHelp": "Berechnungstools für Heizungs-, Klima- und Wärmepumpenanlagenr",
        "newInstallationHelp": "Neue Installation hinzufügen",
        "printInstallationHelp": "Die angezeigte Anlagenliste drucken, unter Berücksichtigung der angewendeten Filter",
        "searchHelp": "Installation mit Adresse, Name oder Referenz suchen",
        "selectInstallationHelp": "Installation auswählen",
        "searchTourneeHelp": "Tour mit Name, Datum, Adresse oder Referenz suchen",
        "selectTourneeHelp": "Tour auswählen",
        "modifyTourneeHelp": "Inhalt oder Reihenfolge der Termine einer Tour ändern",
        "validateTourneeHelp": "Tour bestätigen, sie ist nicht mehr änderbar",
        "detailsTourneeHelp": "Nach Bestätigung können Sie die Details einer Tour sehen",
        "moveMeetingHelp": "Drag & Drop zum Verschieben eines Termins",
        "deleteMeetingHelp": "Termin löschen",
        "addMeetingHelp": "Termin hinzufügen, Liste der nicht planifizierten Installationen",
        "saveTourneeHelp": "Tour speichern, neues Plan wird dem SCRB vorgeschlagen",
        "cancelTourneeHelp": "Änderungen rückgängig machen und Eingaben löschen, zurück zur vorherigen Seite",
        "infosAddMeeting": "Die Anzahl der Termine ist begrenzt in Abhängigkeit vom Brennstofftyp",
        "manageInstallation": "Gestion der Installation",
        "saveInstallationHelp": "Installation speichern, neues Plan wird dem SCRB vorgeschlagen",
        "cancelInstallationHelp": "Änderungen rückgängig machen und Eingaben löschen, zurück zur vorherigen Seite",
        "printManageInstallationHelp": "Das Anlagenblatt drucken.",
        "printPdfHelp":"Um ein PDF zu erzeugen, den Drucker „Microsoft Print to PDF“ wählen, oder „Speichern als PDF“",
        "installations": "Anlagen",
        "certificatGaz": "Konformitätsbescheinigungen",
        "titreCertifFume": "    Konformitätsbescheinigung Abgassystem",
        "titreCertifGaz": "    Konformitätsbescheinigung Gasleitung",
        "certifGaz": "Hiermit bescheinigen wir dass die betroffene Gasleitungsanlage die Dichtheitsprüfung mit Erfolg bestanden hat und den Bestimmungen des Grossherzoglichen Reglementes vom 27. Februar 2010 betreffend die mit Gas betriebenen Feuerungsanlagen entspricht.",
        "certifFume1": "Hiermit bescheinigen wir dass die betroffene Abgasanlage den Bestimmungen des Grossherzoglichen Reglementes vom 27. Februar 2010 betreffend die mit Gas betriebenen Feuerungsanlagen entspricht.",
        "certifFume2": "Eine Bescheinigung der Abgasanlage wurde erstellt vom Schornsteinbauerunternehmen",
        "certifFumiste": "Name der Fumiste",
        "conformite": "Konformität",
        "conforme": "Konform",
        "nonConforme": "Nicht konform",
        "addressTooltip": "Geben Sie eine gültige Adresse ein. Falls diese nicht erkannt wird, geben Sie bitte die Hausnummer und die Straße ein.",
        "aggreationCE": "EG-Zulassung",
        "nouveauRdv": "Neuer Termin",
        "pasDeControle": "Keine Kontrolle",
        "numSerie": "Seriennummer",
        "laboratoires": "Akkumulierte Labore",
        "directeurLabo": "Laborleiter",
        "warning": "Achtung",
        "secretaire": "Sekretär",
        "jaccepte": "Ich habe die",
        "conditionsUtilisation": " Nutzungsbedingungen « Extranet eSCRB » gelesen und akzeptiert",
        "linkConditionsUtilisation": "https://scrb.cdm.lu/de/nutzungsbedingungen",
        "confirmAddress": "Überprüfen Sie die Richtigkeit der gefundenen Adresse! (Postleitzahl, Ort etc...)",
        "nbRdv": "Anzahl der Termine",
        "responsableNom": "Name des zuständigen Baustellenleiters",
        "Extranet User with same mail detected":"Ein Extranet-Benutzer mit demselben E-Mail-Adressen besteht bereits",
        "delegue_tooltip": "Konto mit denselben Rechten wie der Geschäftsführer. Ermöglicht die Erstellung weiterer Benutzer.",
        "delegue_compte": "Ermöglicht dem Geschäftsführer die Verwaltung von Benutzerkonten.",
        "cgu": "Allgemeine Geschäftsbedingungen",
        "accepter": "Ich akzeptiere",
        "refuser": "Ich lehne ab",
        "mailTooltip": "Adresse, die für das Senden der Empfangsprotokolle verwendet wird",
        "infoContact": "Adresse, die zum Empfang von Benachrichtigungen über Tour-Updates und Empfangsprotokollen verwendet wird",

        "typeInstallation0": "nicht definiert",
        "typeInstallation1": "Heizung",
        "typeInstallation2": "Brauchwasser",
        "typeInstallation3": "Heizung mit Brauchwasser",
        "typeInstallation4": "Luftheizung",
        "typeInstallation5": "Sonstiges",
        "typeInstallation6": "Klimaanlage",
        "typeInstallation7": "Wärmepumpe",
        "typeCombustible1": "Heizöl EL",
        "typeCombustible2": "Schweres Heizöl",
        "typeCombustible3": "Altöl",
        "typeCombustible4": "Erdgas",
        "typeCombustible5": "Flüssiggas",
        "typeCombustible6": "Fester Behälter",
        "typeCombustible7": "Behälter beweglich",
        "typeCombustible8": "Holzkohle (1)",
        "typeCombustible9": "Holzkohlebriketts (1)",
        "typeCombustible10": "Steinkohlebriketts (1)",
        "typeCombustible11": "Braunkohlebriketts (1)",
        "typeCombustible12": "Anthrazit (1)",
        "typeCombustible13": "Torfbriketts (2)",
        "typeCombustible14": "unbehandeltes Stückholz mit oder ohne Rinde in der Form von Scheitholz (3)",
        "typeCombustible15": "Hackschnitzel (3)",
        "typeCombustible16": "Brindilles de bois (3)",
        "typeCombustible17": "Reisig und Holzspänen (3)",
        "typeCombustible18": "unbehandeltes Holz in Form von Sägemehl (4)",
        "typeCombustible19": "unbehandeltes Holz in Form von Sägemehl (4)",
        "typeCombustible20": "Staub oder Rinde (4)",
        "typeCombustible21": "Presslinge von unbehandeltem Holz in Form von Briketts oder Pellets (5)",
        "typeCombustible22": "welche ausschließlich mit natürlichem Bindemittel hergestellt worden sind (5)",
        "typeCombustible23": "Stroh oder andere pflanzliche Stoffe (6)",
        "typeCombustible24": "gegebenenfalls Presslinge auf Basis von Stroh oder anderen pflanzlichen Stoffen (6)",
        "typeBatiment0": "nicht definiert",
        "typeBatiment1": "Einfamilienhaus",
        "typeBatiment2": "Mehrfamilienhaus",
        "typeBatiment3": "Verwaltungsgebäude",
        "typeBatiment4": "Gewerbe",
        "typeBatiment5": "Industrie",
        "typeBatiment6": "Sonstiges",
        "typeCondenseur0": "zu definieren",
        "typeCondenseur1": "Kondensator Kältemittel/Luft",
        "typeCondenseur2": "Wassergekühlter Verflüssiger",
        "typeEvaporateur0": "zu definieren",
        "typeEvaporateur1": "Direktverdampfer",
        "typeEvaporateur2": "Verdampfer für Kältemittel/Wasser",
        "utilisation0": "zu definieren",
        "utilisation1": "Kühlung (positive Temperatur)",
        "utilisation2": "Klimaanlage",
        "utilisation3": "Einfrieren (negative Temperatur)",
        "typeChaudiere1": "Atmosphärischer Brenner",
        "typeChaudiere2": "Öl-Spezialkessel",
        "typeChaudiere3": "Wechselbrandkessel",
        "typeChaudiere4": "Brennwertkessel",
        "typeChaudiere5": "Gebläsebrenner",
        "typeChaudiere6": "Gas-Wasserkocher",
        "typeChaudiere7": "Instant-Warmwasserbereiter mit Gas",
        "typeChaudiere8": "Gas-Warmwasserbereiter mit Speicherfunktion",
        "typeChaudiere9": "Gasgeräte mit Doppelbetrieb Heizung/Wasser",
        "typeChaudiere10": "Gaswarmwasserbereiter mit abgedichtetem Kreislauf",
        "typeChaudiere11": "Gasofen",
        "typeChaudiere12": "Konvektionsradiator",
        "typeChaudiere13": "gasbetriebener Heißluftgenerator",
        "typeChaudiere14": "KWK-Anlage elektrische Leistung < bis 100 kW",
        "typeChaudiere15": "Einzelkessel",
        "typeChaudiere16": "Brennwertkessel",
        "typeChaudiere17": "Kombikessel",
        "typeChaudiere18": "Raumheizung mit Anschluss",
        "typeChaudiere19": "Angeschlossener Ofen für Zentralheizung",
        "typeChaudiere20": "Kamineinsatz mit geschlossenem Anschluss",
        "typeChaudiere21": "Kessel mit Wirbelschicht",
        "typeChaudiere22": "Brennwertkessel",
        "typeChaudiere23": "Öl-Spezialkessel",
        "typeChaudiere24": "Luft/Wasser innere",
        "typeChaudiere25": "Luft/Wasser aussen",
        "typeChaudiere26": "Erdwärme",
        "typeChaudiere27": "Luft/Luft",
        "typeChaudiere28": "Andere",
        "typeBruleur1": "Brenner 1-Stufig",
        "typeBruleur2": "Brenner 2-Stufig",
        "typeBruleur3": "Zweistoffbrenner",
        "typeBruleur4": "Modulierender Brenner",
        "typeBruleur5": "Brenner 3-Stufig",
        "modeFonctionnementPompe1": "Monovalent",
        "modeFonctionnementPompe2": "Monoenergetisch",
        "modeFonctionnementPompe3": "Bivalente",
        "genreReception0": "Nicht definiert",
        "genreReception1": "Neue Anlage",
        "genreReception2": "Umänderung Brenner",
        "genreReception3": "Umänderung Kessel",
        "genreReception4": "Umänd. Kessel + Brenner",
        "genreReception5": "Bestehende Anlage",
        "scrb_mazout": "Heizöl",
        "scrb_gaz": "Gas",
        "scrb_clim": "Klimaanlage",
        "scrb_solide": "Festbrennstoff",
        "scrb_pompe_chaleur": "Wärmepumpe",
        "Mazout": "Heizöl",
        "Gaz": "Gas",
        "Fluide réfrigérant": "Klima",
        "Combustible solide": "Festbrennstoff",
        "Pompe à chaleur": "Pumpen",
        "textPompe": "Wärmepumpen, die nach dem 19. September 2025 in Betrieb genommen werden, unterliegen der neuen großherzoglichen Verordnung und müssen unter Wärmepumpe eingetragen werden."
    }
};